/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BoltRegular from './bolt-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoltRegular {...validProps} />;
}

SvgComponent.iconName = 'boltRegular';

export const BoltRegularIcon = svgIconWrapper(SvgComponent);
